import React, { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { searchCities } from '../../services/cities';
import { Col, Form, Row } from 'react-bootstrap';
import CustomButton from '../shared/CustomButton';
import { FaSave } from 'react-icons/fa';
import CustomAsyncSelect from '../form_components/CustomAsyncSelect';

const ClientForm = ({
    client,
    isSaving,
    formAction
}) => {
    const {
        register,
        handleSubmit,
        formState: {errors},
        reset,
        setError,
        control
    } = useForm({defaultValues: client ?
      {
        id: client.id,
        name: client.name,
        city: {
          label: client.city.name,
          value: client.city.id
        },
        email: client.email,
        contact_person: client.contact_person,
        phone: client.phone,
        username: client.username,
        address1: client.address1,
        address2: client.address2
      } : {}
    });

    useEffect(() => {
      if (client) {
        reset({
          id: client.id,
          city: {
            label: client.city.name,
            value: client.city.id
          },
          name: client.name,
          contact_person: client.contact_person,
          email: client.email,
          phone: client.phone,
          username: client.username,
          address1: client.address1,
          address2: client.address2
        });
      } else {
        reset({
          id: '',
          city: null,
          name: '',
          contact_person: '',
          email: '',
          phone: '',
          username: '',
          address1: '',
          address2: ''
        });
      }
    }, [client, reset]);

    const loadCities = async (inputValue) => {
      if (inputValue.length < 3){
        return [];
      }

      try {
        const response = await searchCities(inputValue);
        return response.data.map((city) => ({label: city.name, value: city.id}));
      } catch (error) {
        return [];
      }
    }

    const resetForm = () => {
      reset({
        name: '',
        contact_person: '',
        city: null,
        email: '',
        phone: '',
        username: '',
        address1: '',
        address2: '',
      });
    }

    const onSubmit = async (data) => {
      try {
        const success = await formAction(data);
        if (success){
          resetForm();
        }
      } catch (error) {
        if (error.response && error.response.status === 422){
          Object.keys(error.response.data.errors).forEach((field) => {
            setError(field, {
              type: 'manual',
              message: error.response.data.errors[field][0]
            });
          });
        } else {
          throw error; // other errors will be handled by saveClients() in Clients.jsx
        }
      }
    }

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>

      <Row>

        <Col xl={3} lg={4} md={6} sm={12}>

          <Form.Group>

            <Form.Label htmlFor='name'>Name</Form.Label>
            <input type='text' placeholder='Name' autoComplete='off' autoFocus
              className={`form-control ${errors.name ? 'is-invalid' : ''}`}
              {...register('name', {
                required: 'Enter client\'s name'
              })}
            />
            {errors.name && (
              <div className="invalid-feedback">{errors.name.message}</div>
            )}

          </Form.Group>

        </Col>

        <Col xl={3} lg={4} md={6} sm={12}>

            <Form.Group>
            
              <Form.Label htmlFor='email'>Email Address</Form.Label>
              <input type='email' autoComplete='off' placeholder='Email Address'
                  className={`form-control ${errors.email ? 'is-invalid' : '' }`}
                  {...register('email', {
                      required: 'Enter client\'s email address',
                      pattern: {
                          value: /^[A-z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                          message: 'Email address is not valid'
                      }
                  })}
              />
              {errors.email && (
                  <div className="invalid-feedback">{errors.email.message}</div>
              )}

          </Form.Group>

        </Col>

        <Col xl={3} lg={4} md={6} sm={12}>

            <Form.Group>

                <Form.Label htmlFor='username'>Username</Form.Label>
                <input type='username' autoComplete='off' placeholder='Username'
                  className={`form-control ${errors.username ? 'is-invalid' : ''}`}
                  {...register('username', {
                    required: 'Enter client\'s username',
                    pattern: {
                      value: /^[a-zA-Z0-9]{8,16}$/,
                      message: 'Username must be alpha-numeric with between 8 and 16 characters'
                    }
                  })}
                />
                {errors.username && (
                  <div className="invalid-feedback">{errors.username.message}</div>
                )}

            </Form.Group>

        </Col>

        <Col xl={3} lg={4} md={6} sm={12}>

          <Form.Group>

            <Form.Label htmlFor='phone'>WhatsApp Number</Form.Label>
            <input type='text' autoComplete='off' placeholder='WhatsApp Number'
              className={`form-control ${errors.phone ? 'is-invalid' : ''}`}
              {...register('phone', {
                required: 'Enter client WhatsApp number',
                pattern: {
                    value: /^\+[1-9]\d{1,14}$/,
                    message: 'Phone number must be in international format'
                }
              })}
            />
            {errors.phone && (
              <div className="invalid-feedback">{errors.phone.message}</div>
            )}

          </Form.Group>
        
        </Col>

      </Row>

    <Row>

        <Col xl={3} lg={4} md={6} sm={12}>
          
          <Form.Group>

            <Form.Label htmlFor='address1'>Address Line 1</Form.Label>
            <input type='text' placeholder='Address Line 1' autoComplete='off'
              className={`form-control ${errors.address1 ? 'is-invalid' : ''}`}
              {...register('address1', {
                required: 'Enter your address',
                maxLength: {
                  value: 50,
                  message: 'Address Line 1 should be 50 characters or less'
                }
              })}
            />
            {errors.address1 && (
              <div className="invalid-feedback">{errors.address1.message}</div>
            )}

          </Form.Group>

        </Col>

        <Col xl={3} lg={4} md={6} sm={12}>
            
            <Form.Group>

            <Form.Label htmlFor='address2'>Address Line 2</Form.Label>
            <input type='text' placeholder='Address Line 2' autoComplete='off'
              className={`form-control ${errors.address2 ? 'is-invalid' : ''}`}
              {...register('address2', {
                maxLength: {
                value: 50,
                message: 'Address Line 2 should be 50 characters or less'
    }
              })}
            />
            {errors.address2 && (
              <div className="invalid-feedback">{errors.address2.message}</div>
            )}

          </Form.Group>

        </Col>

        <Col xl={3} lg={4} md={6} sm={12}>
          
          <Form.Group>

            <Form.Label htmlFor='city'>City</Form.Label>
            <CustomAsyncSelect
              name='city'
              control={control}
              placeholder='City'
              loadOptions={loadCities}
              rules={{ required: 'Select city client resides in'}}
            />

          </Form.Group>

        </Col>
        
        <Col xl={3} lg={4} md={6} sm={12}>

            <Form.Group>

              <Form.Label htmlFor='contact_person'>Contact Person</Form.Label>
              <input type='text' placeholder='Contact Person' autoComplete='off'
                className={`form-control ${errors.contact_person ? 'is-invalid' : ''}`}
                {...register('contact_person', {
                  required: 'Enter client contact person\'s name',
                  minLength: {
                    value: 5,
                    message: 'Contact person name must have at least 5 characters'
                  },
                  maxLength: {
                    value: 100,
                    message: 'Contact person name must not have more than 100 characters'
                  },
                  pattern: {
                      value: /^[a-zA-Z\s'-]+$/,
                      message: 'Name must contain letters and spaces only',
                  },
                })}
              />
              {errors.contact_person && (
                <div className="invalid-feedback">{errors.contact_person.message}</div>
              )}

            </Form.Group>
        
        </Col>

      </Row>


      <CustomButton
        isSaving={isSaving}
        title={isSaving ? 'Saving' : 'Save'}
        icon={<FaSave />} />

    </Form>
  )
}

export default ClientForm